export default __webpack_public_path__ + "static/media/metlife-logo.b4f525eb.png";